import { defaultMiddlewareLocalizedTexts } from './default-middleware-localized-texts';

export const frenchMiddleWareTexts = {
  MIDDLEWARE_BANNER_FILE_NULL_ERROR:
    'Une erreur s’est produite lors du téléversement du fichier; veuillez réessayer.',
  MIDDLEWARE_BANNER_FILE_SIZE_WITHOUT_EXTENSION_ERROR:
    'Le fichier dépasse la limite autorisée de {0} Mo. De plus, veuillez téléverser le fichier avec une extension appropriée.',
  MIDDLEWARE_BANNER_FILE_SIZE_EXTENSION_ERROR:
    'Le fichier dépasse la limite autorisée de {0} Mo et les fichiers {1} ne sont pas pris en charge.',
  MIDDLEWARE_BANNER_FILE_WITHOUT_EXTENSION:
    'Erreur survenue lors du téléversement du fichier. Veuillez téléverser le fichier avec une extension appropriée.',
  MIDDLEWARE_BANNER_FILE_EXTENSION_ERROR:
    'Les fichiers {0} ne sont pas pris en charge.',
  MIDDLEWARE_BANNER_FILE_SIZE_ERROR:
    'Le fichier dépasse la limite autorisée de {0} Mo.',
  MIDDLEWARE_BANNER_FILE_IS_EMPTY_ERROR:
    'Il n’est pas possible de joindre ce fichier, car il est vide. Veuillez réessayer avec un autre fichier.',
  MIDDLEWARE_BANNER_ERROR_MESSAGE:
    'Le téléversement a échoué; veuillez réessayer.',
  MIDDLEWARE_BANNER_INTERNET_BACK_ONLINE: 'Vous êtes de nouveau en ligne.',
  MIDDLEWARE_BANNER_NO_INTERNET_CONNECTION:
    'Connexion impossible; veuillez vérifier votre connexion Internet.',
  MIDDLEWARE_MAX_CHARACTER_COUNT_EXCEEDED:
    'Ce message est trop long. Veuillez raccourcir votre message pour éviter l’échec de son envoi.',
  MIDDLEWARE_TYPING_INDICATOR_ONE: '{0} est en train d’écrire...',
  MIDDLEWARE_TYPING_INDICATOR_TWO: '{0} et {1} sont en train d’écrire...',
  MIDDLEWARE_TYPING_INDICATOR_MULTIPLE:
    'Les agents {0} sont en train d’écrire...',
  MIDDLEWARE_MESSAGE_SENDING: 'Envoi en cours ...',
  MIDDLEWARE_MESSAGE_DELIVERED: 'Message envoyé',
  MIDDLEWARE_MESSAGE_NOT_DELIVERED: 'Message non transmis',
  MIDDLEWARE_MESSAGE_RETRY: 'Réessayer',
};

export const loadingPanePropsFrench = {
  LOADINGPANE_TITLE_TEXT: 'Bienvenue à…',
  LOADINGPANE_SUBTITLE_TEXT: 'Soutien en temps réel par clavardage...',
  LOADINGPANE_SPINNER_TEXT: 'Chargement en cours...',
};

export const loadingPanePropsEnglish = {
  LOADINGPANE_TITLE_TEXT: 'Welcome to',
  LOADINGPANE_SUBTITLE_TEXT: 'Live chat support ...',
  LOADINGPANE_SPINNER_TEXT: 'Loading ...',
};

export const dialogOptionsFrench = {
  CLOSE: 'Fermer',
  CANCEL: 'Annuler',
  CLOSE_CONFIRMATION_DIALOG_TITLE: 'Fermer la conversation',
  CLOSE_CONFIRMATION_DIALOG_DESCRIPTION:
    'Êtes-vous sûr de vouloir fermer cette conversation?',
};

export const dialogOptionsFnglish = {
  CLOSE: 'Close',
  CANCEL: 'Cancel',
  CLOSE_CONFIRMATION_DIALOG_TITLE: 'Close Chat',
  CLOSE_CONFIRMATION_DIALOG_DESCRIPTION:
    'Do you really want to close this chat?',
};

export const headerControlPropsFrench = {
  HEADER_TEXT: `Clavardons`,
};

export const headerControlPropsEnglish = {
  HEADER_TEXT: `Let's Chat`,
};

export const ccsChatLocalisedTexts = (chatLocale: string) => {
  switch (chatLocale) {
    case 'fr':
      return {
        middleWareLocalisedTexts: frenchMiddleWareTexts,
        loadingPaneTexts: loadingPanePropsFrench,
        headerControlProps: headerControlPropsFrench,
        dialogOptions: dialogOptionsFrench,
      };

    default:
      return {
        middleWareLocalisedTexts: defaultMiddlewareLocalizedTexts,
        loadingPaneTexts: loadingPanePropsEnglish,
        headerControlProps: headerControlPropsEnglish,
        dialogOptions: dialogOptionsFnglish,
      };
  }
};
